import React from 'react'
import Title from '../../../Common/Title'
// import bg from "../../../../Assets/Images/map-platform.png"
import img from "../../../../Assets/Images/memberimg.png"
import item1 from "../../../../Assets/Images/reason022.png"
import item2 from "../../../../Assets/Images/reason011.png"
import item3 from "../../../../Assets/Images/reason033.png"
import "./styles.scss"

function MemberMap() {
  return (
    <div className='memberMap'>
        
        {/* <div className="memberMap-bg">
            <img src={bg} alt="" />
        </div> */}

        <div className="memberMap-container">
        <Title title={<>{}</>} />
        <div className="map">
            {/* <img src={img} alt="" /> */}
        </div>
        
        <div className="map-list">
          {dataMap.map((item,index) => (
            <div className="item" key={index}>
              <div className="img">
                <img src={item.img} alt="" />
              </div>
              <div className="content">
                <div className="title">{item.title}</div>
                <div className="detail">{item.detail}</div>
              </div>
            </div>
          ))}
        </div>
        
        </div>
    </div>
  )
}

export default MemberMap

const dataMap = [
    {
      img: item1,
      title: '我进行了什么询问？',
      detail: '确认我在CSBYE上的所有咨询和答复！'
    },
    {
      img: item2,
      title: '每日访问时提供累积积分的机会',
      detail: '仅加入就立即支付2000P！'
    },
    {
      img: item3,
      title: '如果问题没有完全解决呢？',
      detail: '确认答复后可在同一服务内追加咨询'
    },
]